var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { stringify } from 'query-string';
import { useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { apiGetOneProffitSearchInformation } from '../../../../actions/ProffitSearchAction';
import { apiCreateProffitSearchGroupAccountAssign, apiCreateProffitSearchGroupAccountLicence, apiCreateProffitSearchGroupAdmin, apiCreateProffitSearchGroupBillingInformation, apiDeleteProffitSearchGroupAccount, apiGetProffitSearchGroup, } from '../../../../actions/ProffitSearchGroupAction';
import { apiGetOneProfile } from '../../../../actions/ProfileActions';
import { notify, wrapDispatch, wrapNotifyError, } from '../../../../helpers/action';
import { getUserMode } from '../../../../helpers/auth';
import { arraySortFuncMultiKeys } from '../../../../helpers/common/ArrayHelper';
import { parseQueryString } from '../../../../helpers/common/QueryStringHelper';
import { propShape } from '../../../../helpers/custom-prop-types';
import { getProffitSearchValues, isProffitSearchFreePlan, } from '../../../../helpers/profile';
import { compose } from '../../../../helpers/recompose';
import { useSlideSearchLockItem } from '../../../../helpers/use/proffit_search/common/useSlideSearchLockItem';
import { useMyPageAccountList } from '../../../../helpers/use/proffit_search/mypage/useMyPageAccountList';
import { useBoolState, useUnmountRef } from '../../../../helpers/use/useHook';
import UserPlusIcon from '../../../Icon/Svg/UserPlusIcon';
import Layout from '../../../Layout';
import Breadcrumb from '../../../Layout/Breadcrumb';
import AuthenticationHoc from '../../../System/AuthenticationHoc';
import ProffitSearchTutorialHoc from '../../../Ui/ProffitSearch/Hoc/ProffitSearchTutorialHoc';
import Hover from '../../../Ui/System/Hover';
import SlideAddButton from '../../Common/Action/Button/SlideAddButton';
import ProffitSearchGroupHoc from '../../Common/Hoc/ProffitSearchGroupHoc';
import SlideSearchRegistrationModals from '../../Common/Modal/SlideSearchRegistrationModals';
import AccountBillingInformation from './Parts/AccountList/AccountBIllingInformation/AccountBillingInformation';
import AccountTable from './Parts/AccountList/AccountTable/AccountTable';
import AccountTableDisabled from './Parts/AccountList/AccountTableDisabled/AccountTableDisabled';
import DisableModal from './Parts/AccountList/DisableModal/DisableModal';
import EditModal from './Parts/AccountList/EditModal/EditModal';
import UpdateModal from './Parts/AccountList/UpdateModal/UpdateModal';
const AccountListInner = (props) => {
    const { group } = props;
    const history = useNavigate();
    const dispatch = useDispatch();
    const profile = useSelector((state) => state.profile);
    const auth = useSelector((state) => state.auth);
    const { canRegistrationTrial } = useMemo(() => getProffitSearchValues(profile), [profile]);
    const userMode = getUserMode(auth);
    const { pathname, search } = useLocation();
    const unMountRef = useUnmountRef();
    const { list = [] } = group;
    const { enableDomains = [] } = profile;
    const { hasGroupAccount, plan } = useMemo(() => getProffitSearchValues(profile), [profile]);
    const isFree = isProffitSearchFreePlan(plan);
    const pans = useMemo(() => [
        {
            link: '/mypage',
            text: 'マイページ',
        },
        {
            link: '/proffit_search',
            text: 'PROFFIT SEARCH',
        },
        {
            text: 'アカウント管理',
        },
    ], []);
    const { formatQuery, query } = useMemo(() => parseQueryString(search, [
        { name: 'sort', selects: ['position', 'expiredAt'] },
        { name: 'order', selects: ['asc', 'desc'] },
    ]), [search]);
    const { boolState: isShowDisable, changeToggle } = useBoolState(false);
    const { disableRows, enableRows, newRows } = useMemo(() => {
        const safeList = [...list]
            .map((v) => (Object.assign(Object.assign({}, v), { position: v.position === '' ? '99' : v.position })))
            .sort((leftValue, rightValue) => arraySortFuncMultiKeys(leftValue, rightValue, [
            {
                adjust: formatQuery.order === 'asc' ? 1 : -1,
                name: formatQuery.sort,
            },
            {
                adjust: 1,
                name: 'purchaseAt',
            },
            {
                adjust: 1,
                name: 'id',
            },
        ]));
        return {
            disableRows: safeList.filter((v) => v.hasUser && v.isDisabled),
            enableRows: safeList.filter((v) => v.hasUser && !v.isDisabled),
            newRows: safeList.filter((v) => !v.hasUser),
        };
    }, [list, formatQuery.sort, formatQuery.order]);
    const [checkList, changeCheckList] = useState([]);
    const onChangeAllCheck = useCallback((e) => {
        if (e.currentTarget.checked) {
            changeCheckList(enableRows
                .filter((v) => !v.isDisabled && !v.isInvalidMail)
                .map((v) => v.id));
        }
        else {
            changeCheckList([]);
        }
    }, [changeCheckList, enableRows]);
    const onChangeCheck = useCallback((e) => {
        const { checked, value: rawValue } = e.currentTarget;
        const value = parseInt(rawValue, 10);
        changeCheckList((prev) => {
            const omit = [...prev].filter((v) => v !== value);
            if (checked) {
                return [...omit, value];
            }
            return omit;
        });
    }, [changeCheckList]);
    const onClickSort = useCallback((e) => {
        const newSort = e.currentTarget.value;
        if (!newSort) {
            return;
        }
        let newOrder;
        if (['position', 'expiredAt'].includes(formatQuery.sort) &&
            ['asc', 'desc'].includes(formatQuery.order) &&
            formatQuery.sort === newSort &&
            formatQuery.order === 'desc') {
            // 同じsortが存在する場合はorderを反転
            newOrder = 'asc';
        }
        else {
            newOrder = 'desc';
        }
        const newQuery = stringify(Object.assign(Object.assign({}, query), { order: newOrder, sort: newSort }));
        history.push(`${pathname}?${newQuery}`);
    }, [history, pathname, query, formatQuery.order, formatQuery.sort]);
    const { boolState: isShowUpdateModal, changeFalse: hideUpdateModal, changeTrue: showUpdateModal, } = useBoolState(false);
    const { boolState: isShowDisableModal, changeFalse: hideDisableModal, changeTrue: showDisableModal, } = useBoolState(false);
    const [disableAccountInitialValues, changeDisableAccountInitialValues] = useState({});
    const unmountRef = useUnmountRef();
    /**
     * アカウントの削除を押した際のイベント
     * @type {(function(*, *, *): Promise<void>)|*}
     */
    const onClickDisableAccount = useCallback((e) => {
        const { value } = e.currentTarget;
        const id = parseInt(value, 10);
        const account = list.find((v) => v.id === id) || {};
        changeDisableAccountInitialValues({
            email: account.email,
            id: account.id,
        });
        showDisableModal();
    }, [changeDisableAccountInitialValues, list, showDisableModal]);
    /**
     * アカウント削除の確認モーダルで、削除を実行した際のイベント
     * @type {(function(*, *, *): Promise<void>)|*}
     */
    const onSubmitDisableAccount = useCallback((formValues) => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            yield wrapDispatch(dispatch, apiDeleteProffitSearchGroupAccount(formValues.id));
            yield Promise.all([
                wrapDispatch(dispatch, apiGetProffitSearchGroup()),
                wrapDispatch(dispatch, apiGetOneProffitSearchInformation()),
                // ヘッダーのバッジ状態を更新するため、プロフィールを引き直す
                wrapDispatch(dispatch, apiGetOneProfile()),
            ]);
            if (!unmountRef.current) {
                hideDisableModal();
                notify('アカウントを停止しました');
            }
        }));
    }), [dispatch, hideDisableModal, unmountRef]);
    const onSubmitNewAccount = useCallback((values, unUse, formProps) => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            const { item: { id: itemId }, } = formProps;
            const params = {
                email: values.email,
            };
            yield wrapDispatch(dispatch, apiCreateProffitSearchGroupAccountAssign(itemId, params));
            yield Promise.all([
                wrapDispatch(dispatch, apiGetProffitSearchGroup()),
                wrapDispatch(dispatch, apiGetOneProffitSearchInformation()),
                // ヘッダーのバッジ状態を更新するため、プロフィールを引き直す
                wrapDispatch(dispatch, apiGetOneProfile()),
            ]);
            if (!unmountRef.current) {
                notify('アカウントを追加しました');
            }
        }));
    }), [dispatch, unmountRef]);
    const onSubmitAdmin = useCallback((values) => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            const { admin } = values;
            const params = { adminEmail: admin };
            yield wrapDispatch(dispatch, apiCreateProffitSearchGroupAdmin(params));
            if (!unmountRef.current) {
                yield Promise.all([
                    wrapDispatch(dispatch, apiGetProffitSearchGroup()),
                    wrapDispatch(dispatch, apiGetOneProffitSearchInformation()),
                    wrapDispatch(dispatch, apiGetOneProfile()),
                ]);
            }
            if (!unmountRef.current) {
                notify('ご請求責任者を保存しました');
            }
        }));
    }), [dispatch, unmountRef]);
    const onSubmitBillingInformation = useCallback((values) => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            const { billingInformation = [] } = values;
            const params = {
                billingInformation: billingInformation.map((value) => ({
                    email: value.email,
                    name: value.name,
                })),
            };
            yield wrapDispatch(dispatch, apiCreateProffitSearchGroupBillingInformation(params));
            if (!unmountRef.current) {
                yield Promise.all([
                    wrapDispatch(dispatch, apiGetProffitSearchGroup()),
                    wrapDispatch(dispatch, apiGetOneProffitSearchInformation()),
                ]);
            }
            if (!unmountRef.current) {
                notify('請求書送付先を保存しました');
            }
        }));
    }), [dispatch, unmountRef]);
    const updateInitialValue = useMemo(() => ({
        id: checkList,
    }), [checkList]);
    const onSubmitUpdateModal = useCallback((values) => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            yield wrapDispatch(dispatch, apiCreateProffitSearchGroupAccountLicence(values));
            if (!unmountRef.current) {
                yield Promise.all([
                    wrapDispatch(dispatch, apiGetProffitSearchGroup()),
                    wrapDispatch(dispatch, apiGetOneProffitSearchInformation()),
                ]);
            }
            if (!unmountRef.current) {
                notify('アカウントの期限を更新しました');
                hideUpdateModal();
                changeCheckList([]);
            }
        }));
    }), [dispatch, hideUpdateModal, changeCheckList, unmountRef]);
    const useAccountEdit = useMyPageAccountList.useMyPageAccountEdit(unmountRef, list);
    const { email, hideCompleteModal, hideFormModal, hidePaidModal, initialValues, isShowCompleteModal, isShowFormModal, isShowPaidModal, kanaRef, onClickLockItem, onSubmitRegistration, } = useSlideSearchLockItem.useSlideSearchLockItemModal(profile, userMode, dispatch, unmountRef);
    return (_jsx(Layout, Object.assign({ headerType: 'proffit_search', mainClassName: 'l-main slide_search_page slide_search_mypage_account_list_page', sticky: _jsx(SlideAddButton, { disabled: isFree, onClickLockItem: onClickLockItem }), stickyClassName: 'slide_search_page add_button_footer' }, { children: _jsxs("div", Object.assign({ className: 'l-container' }, { children: [_jsx(Breadcrumb, { lists: pans }), _jsx("div", Object.assign({ className: 'mypage_container' }, { children: _jsxs("div", Object.assign({ className: 'mypage_content' }, { children: [_jsxs("div", Object.assign({ className: 'mypage_content_section' }, { children: [_jsx("h2", Object.assign({ className: 'mypage_content_section_title' }, { children: "\u30A2\u30AB\u30A6\u30F3\u30C8\u30EA\u30B9\u30C8" })), _jsx("div", Object.assign({ className: 'proffit_search_account_action' }, { children: _jsxs(Link, Object.assign({ className: 'action_button button link', to: '/proffit_search/account_add' }, { children: [_jsx(UserPlusIcon, { className: 'white' }), _jsx("span", { children: "\u30E1\u30F3\u30D0\u30FC\u8FFD\u52A0" })] })) })), _jsx("div", Object.assign({ className: 'proffit_search_table_box' }, { children: _jsx(AccountTable, { adminId: group.admin && group.admin.id, checkList: checkList, editableRowsObj: useAccountEdit.initialValuesObj, enableDomains: enableDomains, enableRows: enableRows, newRows: newRows, onChangeAllCheck: onChangeAllCheck, onChangeCheck: onChangeCheck, onClickDisableAccount: onClickDisableAccount, onClickEditAccount: useAccountEdit.onClickRowEdit, onClickEditCancelAccount: useAccountEdit.onClickRowCancel, onClickSort: onClickSort, onClickUpdate: showUpdateModal, onSubmitEditAccount: useAccountEdit.onSubmit, onSubmitNewAccount: onSubmitNewAccount, order: formatQuery.order, profile: profile, sort: formatQuery.sort }) })), disableRows.length > 0 && (_jsx(Hover, { children: _jsx("button", Object.assign({ className: 'show_disable_button', onClick: changeToggle, type: 'button' }, { children: isShowDisable
                                                ? '無効にしたアカウントリストを閉じる'
                                                : '無効にしたアカウントリストを見る' })) }))] })), isShowDisable && disableRows.length > 0 && (_jsx(AccountTableDisabled, { disableRows: disableRows })), hasGroupAccount && (_jsx(AccountBillingInformation, { accountMember: group, enableDomains: enableDomains, onSubmitAdmin: onSubmitAdmin, onSubmitBillingInformation: onSubmitBillingInformation }))] })) })), _jsx(UpdateModal, { accountMember: group, checkIdList: checkList, hideModal: hideUpdateModal, initialValues: updateInitialValue, isShow: isShowUpdateModal && checkList.length > 0, onSubmit: onSubmitUpdateModal }), _jsx(DisableModal, { hideModal: hideDisableModal, initialValues: disableAccountInitialValues, isShow: isShowDisableModal, onSubmit: onSubmitDisableAccount }), _jsx(EditModal, { email: useAccountEdit.email, hideModal: useAccountEdit.hideEditModal, id: useAccountEdit.id, isShow: useAccountEdit.isShowEditModal, onClickEdit: useAccountEdit.onClickModalEdit }), _jsx(SlideSearchRegistrationModals, { canRegistrationTrial: canRegistrationTrial, email: email, hideCompleteModal: hideCompleteModal, hideFormModal: hideFormModal, hidePaidModal: hidePaidModal, initialValues: initialValues, isShowCompleteModal: isShowCompleteModal, isShowFormModal: isShowFormModal, isShowPaidModal: isShowPaidModal, kanaRef: kanaRef, onSubmitRegistration: onSubmitRegistration, unMountRef: unMountRef, userMode: userMode })] })) })));
};
AccountListInner.propTypes = {
    group: propShape().isRequired,
};
const AccountList = compose(AuthenticationHoc({ isCanUseProffitSearch: true }), ProffitSearchGroupHoc(), ProffitSearchTutorialHoc())(AccountListInner);
export default AccountList;
